module.exports = __webpack_public_path__ + "static/media/Live.83f272b6.png";